import React from 'react'
import { links } from 'common/helpers'

import WidthContainer from 'components/_new/layout/widthContainer/WidthContainer/WidthContainer'
import HeaderHeight from 'layouts/InsideLayout/Header/HeaderHeight/HeaderHeight'
import NavItem from 'layouts/InsideLayout/Header/HeaderNavItem/HeaderNavItem'
import NavItemTitle from 'layouts/InsideLayout/Header/HeaderNavItemTitle/HeaderNavItemTitle'
import Logo from 'components/ui/Logo/Logo'

import Nav from './Nav/Nav'

import messages from './messages'
import s from './NoAuth.scss'


const HeaderNoAuth = () => {
  const logoProps = { redirect: links.home }

  return (
    <header className={s.header}>
      <WidthContainer className={s.content} role="menubar">
        <HeaderHeight>
          <NavItem className={s.logoNavItem}>
            <Logo className={s.logo} light {...logoProps} />
          </NavItem>
        </HeaderHeight>
        <Nav className={s.navigation} />
        <NavItem>
          <NavItemTitle uppercase title={messages.login} to={links.login} />
        </NavItem>
      </WidthContainer>
    </header>
  )
}


export default HeaderNoAuth
